export default {
  propertyLocations: [],
  properties: [],
};
